import React from "react";
import { motion } from "framer-motion";
import { FaExternalLinkAlt, FaDownload } from "react-icons/fa";

const ProjectModal = ({ project, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
    <motion.div
      className="bg-[#1e1b4b] rounded-2xl p-6 w-full max-w-2xl text-white relative"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
    >
      <button
        className="absolute top-3 right-4 text-gray-400 hover:text-red-400 text-2xl"
        onClick={onClose}
      >
        ✕
      </button>

      <h2 className="text-3xl font-bold mb-4 text-indigo-400">
        {project.title}
      </h2>

      <img
        src={project.image}
        alt={project.title}
        className="rounded-lg w-full h-64 object-cover shadow-lg mb-4"
      />

      <p className="text-gray-300 mb-6">{project.description}</p>

      <div className="flex justify-center gap-4">
        <a
          href={project.download}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-indigo-500 hover:bg-indigo-600 px-4 py-2 rounded-lg transition"
        >
          <FaDownload /> Download
        </a>
      </div>
    </motion.div>
  </div>
);

export default ProjectModal;
